// extracted by mini-css-extract-plugin
export default {"tab_main":"CompareList_tab_main__w82jB","delete_div":"CompareList_delete_div__WMfPV","page":"CompareList_page__2WMXI","sort_div":"CompareList_sort_div__klQbS"};